import React, { ChangeEvent, useEffect, useState } from "react"
import { makeStyles, ThemeProvider } from "@material-ui/core/styles"
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Divider,
  DialogActions,
  Grid,
  DialogTitle,
  FormControl,
  TextareaAutosize,
  FormHelperText,
} from "@material-ui/core"
import CustomInput from "../../../../../Components/CustomInput"
import DataService from "../../../../../Service"
import { useDispatch } from "react-redux"
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions"
import HomeHeaderMenu from "../../../../../Components/HeaderMenuComponent/EmpComponent"
import { fontTheme } from "../../../../../fontTheme"

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
  },
  title: {
    textTransform: "none",
  },
  dialog_title: {
    "& h6": {
      fontSize: "18px",
      fontFamily: "Open Sans",
      fontWeight: "700",
    },
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "97%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    fontSize: "16px",
    fontFamily: "Open Sans",

    display: "block",
    outline: "none",

    "&:focus": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
}))

interface ICurrentSelection {
  description: string
  id: number
  max_duration: string
  measure: string
  min_duration: string
  organisations?: Array<[]>
  tableData?: any
}

interface IProps {
  isOpen: any

  onClose(): void

  fetchSLA(): void

  currentSelection?: ICurrentSelection
}

const SLAModal: (props: IProps) => JSX.Element = (props: IProps) => {
  const { isOpen, onClose, fetchSLA, currentSelection } = props

  const [textAreaValue, setTextAreaValue] = useState<any>({})
  const [inputValue, setInputValue] = useState<any>({})
  const [submitClickFlag, setSubmitClickFlag] = useState<boolean>(false)

  const classes = useStyles()
  const dispatch = useDispatch()

  const handleChangeTextArea = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event?.target
    setTextAreaValue({ ...textAreaValue, [name]: value })
  }

  const handleInputChange = (inputStateValue: string, inputName: string) => {
    setInputValue({ ...inputValue, [inputName]: inputStateValue })
  }

  useEffect(() => {
    if (currentSelection) {
      setInputValue({
        max_duration: currentSelection?.max_duration || "",
        min_duration: currentSelection?.min_duration || "",
      })
      setTextAreaValue({
        description: currentSelection?.description || "",
        measure: currentSelection?.measure || "",
      })
    }
  }, [currentSelection])

  const handleSubmit = (event: any) => {
    event.preventDefault()
    const formData: any = new FormData(event.target)

    if (inputValue && textAreaValue) {
      if (isOpen == "createSLA") {
        DataService.createData(formData, "create_SLA")
          .then((res: any) => {
            if (res?.["success"]) {
              dispatch(showSnackbar("success", [res?.message], 5000))
              setSubmitClickFlag(false)
              fetchSLA()
              onClose()
            }
          })
          .catch((error) => {
            setSubmitClickFlag(true)
            console.log("Error", error)
          })
      } else {
        formData.append("SLA_id", currentSelection?.id)
        DataService.updateData(formData, null, "update_SLA")
          .then((res: any) => {
            if (res?.["success"]) {
              setSubmitClickFlag(false)
              dispatch(showSnackbar("success", [res?.message]))

              fetchSLA()
              onClose()
            }
          })
          .catch((error) => {
            setSubmitClickFlag(true)
            console.log("Error", error)
          })
      }
    } else {
      setSubmitClickFlag(true)
    }
  }

  return (
    <>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={isOpen}
        onClose={() => onClose()}
        aria-labelledby="base-station-manage"
      >
        <form spellCheck="false" onSubmit={handleSubmit}>
          <DialogTitle
            id="customized-dialog-title"
            // className={classes.dialog_title}
          >
            {" "}
            <Typography
              variant="subtitle1"
              style={{
                fontSize: "18px",
                fontFamily: "Open Sans",
                fontWeight: "700",
              }}
            >
              Setting up SLA
            </Typography>
          </DialogTitle>
          <Divider />
          <DialogContent style={{ margin: "10px" }}>
            <div className={classes.formWrapper}>
              <div>
                <ThemeProvider theme={fontTheme}>
                  <Grid
                    container
                    spacing={1}
                    justify={"flex-start"}
                    style={{ marginBottom: 10 }}
                  >
                    <Grid item xs={3} alignItems={"flex-start"}>
                      <Typography variant="h2" className={classes.title}>
                        Measure
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      {/* <FormControl style={{ width: '100%' }} variant="outlined"> */}
                      <TextareaAutosize
                        aria-label="minimum height"
                        name={`measure`}
                        rowsMin={4}
                        autoFocus
                        className={classes.textAreaEmpty}
                        onChange={handleChangeTextArea}
                        value={textAreaValue?.measure}
                        style={
                          submitClickFlag && !textAreaValue?.measure
                            ? { border: "1px solid red" }
                            : {}
                        }
                        placeholder="Measure"
                      />
                      {submitClickFlag && !textAreaValue?.measure ? (
                        <FormHelperText style={{ color: "red" }}>
                          Please enter the measure
                        </FormHelperText>
                      ) : (
                        <></>
                      )}
                      {/* </FormControl> */}
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    alignItems={"center"}
                    justify={"flex-start"}
                    style={{ marginBottom: 10 }}
                  >
                    <Grid item xs={3}>
                      <Typography variant="h2" className={classes.title}>
                        Min duration
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <FormControl
                        style={{
                          width: "100%",
                          fontSize: "16px",
                          fontFamily: "Open Sans",
                        }}
                        variant="outlined"
                      >
                        <CustomInput
                          placeholder={"Min duration"}
                          error={
                            submitClickFlag && !inputValue?.min_duration
                              ? true
                              : false
                          }
                          helperText={
                            submitClickFlag && !inputValue?.min_duration
                              ? "Please enter the mix duration."
                              : ""
                          }
                          variant="outlined"
                          id="min_duration"
                          name="min_duration"
                          parentcall={handleInputChange}
                          value={inputValue?.min_duration}
                          InputLabelProps={{ shrink: true }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    alignItems={"center"}
                    justify={"flex-start"}
                    style={{ marginBottom: 10 }}
                  >
                    <Grid item xs={3}>
                      <Typography variant="h2" className={classes.title}>
                        Max duration
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <FormControl
                        style={{
                          width: "100%",
                          fontSize: "14px",
                          fontFamily: "Open Sans",
                          lineHeight: "16px",
                        }}
                        variant="outlined"
                      >
                        <CustomInput
                          placeholder={"Max duration"}
                          error={
                            submitClickFlag && !inputValue?.max_duration
                              ? true
                              : false
                          }
                          helperText={
                            submitClickFlag && !inputValue?.max_duration
                              ? "Please enter the max duration."
                              : ""
                          }
                          variant="outlined"
                          id="max_duration"
                          name="max_duration"
                          parentcall={handleInputChange}
                          value={inputValue?.max_duration}
                          InputLabelProps={{ shrink: true }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1} justify={"flex-start"}>
                    <Grid item xs={3} alignItems={"flex-start"}>
                      <Typography variant="h2" className={classes.title}>
                        Description
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      {/* <FormControl style={{ width: '100%' }} variant="outlined"> */}
                      <TextareaAutosize
                        aria-label="minimum height"
                        name={`description`}
                        rowsMin={4}
                        style={
                          submitClickFlag && !textAreaValue?.description
                            ? { border: "1px solid red" }
                            : {}
                        }
                        className={classes.textAreaEmpty}
                        onChange={handleChangeTextArea}
                        value={textAreaValue?.description}
                        placeholder="Description"
                      />
                      {submitClickFlag && !textAreaValue?.description ? (
                        <FormHelperText style={{ color: "red" }}>
                          Please enter the description
                        </FormHelperText>
                      ) : (
                        <></>
                      )}
                      {/* </FormControl> */}
                    </Grid>
                  </Grid>
                </ThemeProvider>
              </div>
            </div>
          </DialogContent>
          <ThemeProvider theme={fontTheme}>
            <DialogActions>
              <Button
                onClick={() => onClose()}
                disableElevation
                type="button"
                style={{ textTransform: "none" }}
                variant={"contained"}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                type="submit"
                style={{ textTransform: "capitalize" }}
                variant={"contained"}
                color="secondary"
              >
                {isOpen === "createSLA" ? "Create" : "Update"}
              </Button>
            </DialogActions>
          </ThemeProvider>
        </form>
      </Dialog>
    </>
  )
}
export default SLAModal
